
interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    {name: 'typeform', src: '//embed.typeform.com/next/embed.js'},
    //{name: 'on-submit', src: 'script-on-submit.js'},
];